import {Dispatch} from "redux";
import {Metabase} from "../../services";
import {Change, Project} from "../../models";

interface MetabaseState {
    generalDashboard?: string,
    projectId?: string,
    projectDashboard?: string,
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
    error?: string;
}

const initialState: MetabaseState = { loading: 'idle' };

// Actions types
const GET_GENERAL_DASHBOARD_URL         = 'yoda/metabase/GET_GENERAL_DASHBOARD_URL';
const GET_GENERAL_DASHBOARD_URL_SUCCESS = 'yoda/metabase/GET_GENERAL_DASHBOARD_URL_SUCCESS';
const GET_GENERAL_DASHBOARD_URL_FAILURE = 'yoda/metabase/GET_GENERAL_DASHBOARD_URL_FAILURE';
const GET_GENERAL_DASHBOARD_URL_RESET   = 'yoda/metabase/GET_GENERAL_DASHBOARD_URL_RESET';
const GET_PROJECT_DASHBOARD_URL         = 'yoda/metabase/GET_PROJECT_DASHBOARD_URL';
const GET_PROJECT_DASHBOARD_URL_SUCCESS = 'yoda/metabase/GET_PROJECT_DASHBOARD_URL_SUCCESS';
const GET_PROJECT_DASHBOARD_URL_FAILURE = 'yoda/metabase/GET_PROJECT_DASHBOARD_URL_FAILURE';
const GET_PROJECT_DASHBOARD_URL_RESET   = 'yoda/metabase/GET_PROJECT_DASHBOARD_URL_RESET';


export const getGeneralDashboardUrl = () => async (dispatch: Dispatch) => {
    dispatch({ type: GET_GENERAL_DASHBOARD_URL });
    try {
        const { url } = await Metabase.getGeneralDashboardUrl();
        dispatch({ type: GET_GENERAL_DASHBOARD_URL_SUCCESS, url });
    } catch (error) {
        dispatch({ type: GET_GENERAL_DASHBOARD_URL_FAILURE, error });
    }
};
export const resetGeneralDashboardUrl = () => (dispatch: Dispatch) => dispatch({ type: GET_GENERAL_DASHBOARD_URL_RESET });

export const getProjectDashboardUrl = (projectId: string) => async (dispatch: Dispatch) => {
    dispatch({ type: GET_PROJECT_DASHBOARD_URL, projectId });
    try {
        const { url } = await Metabase.getProjectDashboardUrl(projectId);
        dispatch({ type: GET_PROJECT_DASHBOARD_URL_SUCCESS, url });
    } catch (error) {
        dispatch({ type: GET_PROJECT_DASHBOARD_URL_FAILURE, error });
    }
};
export const resetProjectDashboardUrl = () => (dispatch: Dispatch) => dispatch({ type: GET_PROJECT_DASHBOARD_URL_RESET });

// Reducer
const metabaseReducer = (state: MetabaseState = initialState, action: any): MetabaseState => {
    switch (action.type) {
        case GET_GENERAL_DASHBOARD_URL:
            return {
                ...state,
                loading: 'pending',
                error: undefined
            };
        case GET_GENERAL_DASHBOARD_URL_SUCCESS:
            return { ...state, loading: 'succeeded', generalDashboard: action.url };
        case GET_GENERAL_DASHBOARD_URL_FAILURE:
            return { ...state, loading: 'failed', error: action.error };
        case GET_GENERAL_DASHBOARD_URL_RESET:
            return { ...initialState };
        case GET_PROJECT_DASHBOARD_URL:
            return {
                ...state,
                projectId: action.projectId,
                loading: 'pending',
                error: undefined
            };
        case GET_PROJECT_DASHBOARD_URL_SUCCESS:
            return { ...state, loading: 'succeeded', projectDashboard: action.url };
        case GET_PROJECT_DASHBOARD_URL_FAILURE:
            return { ...state, loading: 'failed', error: action.error };
        case GET_PROJECT_DASHBOARD_URL_RESET:
            return { ...initialState };
        default:
            return state;
    }
};

export default metabaseReducer;
